import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=725eb46f&scoped=true&"
import script from "./MyPage.vue?vue&type=script&lang=ts&"
export * from "./MyPage.vue?vue&type=script&lang=ts&"
import style0 from "./MyPage.vue?vue&type=style&index=0&id=725eb46f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725eb46f",
  null
  
)

export default component.exports